export default __webpack_public_path__ + "static/media/June2019.c4518e6e.png";